/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_By_QuantityInputs */



/**
* | output |
* | --- |
* | "By Number of Events" |
*
* @param {Segment_Event_Group_By_QuantityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_by_quantity = /** @type {((inputs?: Segment_Event_Group_By_QuantityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_By_QuantityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par nombre d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Anzahl der Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per numero di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("По количеству событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por número de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按事件数量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント数別")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयोजनों की संख्या के अनुसार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por número de eventos")
	return /** @type {LocalizedString} */ ("By Number of Events")
});